import { AlertColor } from "@mui/material";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export const useAlert = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [message, setMessage] = useState<string | JSX.Element>();
  const [severity, setSeverity] = useState<AlertColor>("success");

  const setAlert = (
    customMessage: string | JSX.Element,
    customType: AlertColor,
  ) => {
    setMessage(customMessage);
    setSeverity(customType);
  };

  const closeAlert = () => {
    setMessage("");
    if (
      searchParams.get("checkout") === "success" ||
      searchParams.get("checkout") === "failed" ||
      searchParams.get("checkout") === "failed_payment"
    ) {
      searchParams.delete("checkout");
      setSearchParams(searchParams);
    }
  };
  return [message, severity, setAlert, closeAlert] as const;
};
